import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=563357e0&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=563357e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563357e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563357e0')) {
      api.createRecord('563357e0', component.options)
    } else {
      api.reload('563357e0', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=563357e0&scoped=true&", function () {
      api.rerender('563357e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/comp/DateRange.vue"
export default component.exports